import styled, { css } from 'styled-components';

import Box from '../Box';
import applyResponsiveVdpStyles from '../../helpers/applyResponsiveVdpStyles';
import isOmpPlatform from '../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();

/**
 * Variant Definitions
 */
const StyledVdpBoxVariants = {
  mini: css`
    padding: 30px 18px 36px;
  `,
  expanded: css`
    background-color: ${({ theme }) => theme.COLORS.BASE};
    ${({ theme }) =>
      isOmp
        ? css`
            border: 1px solid ${theme.COLORS.NEUTRAL_110};
          `
        : css`
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
          `}
    margin: 9px 0;
    padding: 36px;
  `
};

const DividerVariants = {
  mini: css`
    display: block;
  `,
  expanded: css`
    display: none;
  `
};

/**
 * Styled Components
 */
export const StyledVdpBox = styled(Box)`
  width: 100%;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledVdpBoxVariants.mini,
      expanded: StyledVdpBoxVariants.expanded
    })}
`;

export const Divider = styled.div`
  border-top: 3px solid
    ${({ theme }) => (isOmp ? theme.COLORS.NEUTRAL_110 : '#dbdbdb')};
  width: 100%;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: DividerVariants.mini,
      expanded: DividerVariants.expanded
    })}
`;
